<template>
  <el-dialog
    v-model="dialogVisible"
    :show-close="false"
    :close-on-click-modal="false"
    width="95%"
    top="30vh"
    class="confirm-modal"
  >
    <h5 class="title">
      {{ title }}
    </h5>
    <p
      class="content"
      v-html="content"
    />
    <span
      v-if="vertical"
      class="sub-content"
    >※受取時間は、多少前後する場合がございます。</span>
    <template #footer>
      <div :class="['btn-footer', vertical ? 'vertical' : '']">
        <button
          class="cancel"
          @click="closeModal"
        >
          {{ textCancel }}
        </button>
        <button
          class="submit"
          :disabled="disabledFlag"
          @click="submit"
        >
          {{ textSubmit }}
        </button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'ConfirmModal',
  props: {
    title: {
      type: String,
      default: '商品を削除します'
    },
    content: {
      type: String,
      default: ''
    },
    textCancel: {
      type: String,
      default: 'キャンセル'
    },
    textSubmit: {
      type: String,
      default: '変更する'
    },
    vertical: {
      type: Boolean,
      default: false
    },
    disabledFlag: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit, expose }) {
    const dialogVisible = ref(false)

    const show = () => {
      dialogVisible.value = true
    }

    const closeModal = () => {
      dialogVisible.value = false
    }

    const submit = () => {
      emit('submit')
      closeModal()
    }

    expose({
      show,
      closeModal
    })

    return {
      dialogVisible,
      show,
      closeModal,
      submit
    }
  }
}
</script>
